/**
 * Language switcher dropdown behavior for the .mdh__language block.
 */
export function initNavLanguage() {
  const root = document.querySelector('.mdh__language');
  if (!root) {
    return;
  }
  const button = root.querySelector('button');
  const list = root.querySelector('ul');
  if (!button || !list) {
    return;
  }

  function setOpen(open) {
    button.setAttribute('aria-expanded', String(open));
    list.hidden = !open;
  }

  button.addEventListener('click', () => {
    setOpen(list.hidden);
  });

  document.addEventListener('mousedown', (event) => {
    if (!event.target.closest('.mdh__language')) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setOpen(false);
    }
  });
}
